var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "hub-detail bg-white"
  }, [_c('div', {
    staticClass: "flex justify-between items-stretch mdmax:flex-col shadow-border-b"
  }, [_c('div', {
    staticClass: "flex-1 shadow-border-r p-6 mdmax:shadow-border-b mdmax:flex-auto mdmax:w-full"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Drop Point")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("ID")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.hubDetail.id))])]), _c('div', {
    staticClass: "mb-6 flex gap-6"
  }, [_c('div', {
    staticClass: "w-44"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Nama Hub")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.hubDetail.name || '-'))])]), _c('div', {
    staticClass: "w-44"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Kode Hub")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.hubDetail.hub_code || '-'))])])]), _c('div', {
    staticClass: "mb-6 flex gap-6"
  }, [_c('div', {
    staticClass: "w-44 mdmax:flex-1 mdmax:w-auto"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Latitude")]), _c('p', {
    staticClass: "text-neutral-500 break-all"
  }, [_vm._v(_vm._s(_vm.hubDetail.coord_lat || '-'))])]), _c('div', {
    staticClass: "w-44 mdmax:flex-1 mdmax:w-auto"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Longitude")]), _c('p', {
    staticClass: "text-neutral-500 break-all"
  }, [_vm._v(_vm._s(_vm.hubDetail.coord_lng || '-'))])])]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 block"
  }, [_vm._v("Map")]), _c('a', {
    staticClass: "text-primary-500",
    attrs: {
      "href": `https://maps.google.com/?q=${_vm.hubDetail.coord_lat},${_vm.hubDetail.coord_lng}`,
      "target": "_blank"
    }
  }, [_vm._v("Lihat di google Map")])]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Jam Operasional")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.hubDetail.operation_hour_display || '-'))])]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Alamat")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.hubDetail.address || '-'))])]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Provinsi")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.hubDetail.province_name || '-'))])]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Kota / Kabupaten")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.hubDetail.district_name || '-'))])]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Kecamatan")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.hubDetail.subdistrict_name || '-'))])]), _c('div', {}, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Kelurahan")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.hubDetail.urbanvillage_name || '-'))])])]), _c('div', {
    staticClass: "flex-1 mdmax:flex-auto mdmax:w-full"
  }, [_c('div', {
    staticClass: "p-6"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("PIC")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Nama PIC 1")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.hubDetail.primary_pic_name || '-'))])]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("No Handphone")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.hubDetail.primary_pic_phoneno || '-'))])]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Nama PIC 2")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.hubDetail.secondary_pic_name || '-'))])]), _c('div', {}, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("No Handphone")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.hubDetail.secondary_pic_phoneno || '-'))])])])])]), _c('div', {
    staticClass: "flex gap-6 p-6 justify-end mdmax:justify-center"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Hapus",
      "type": "delete",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.toggleDeleteModal();
      }
    }
  })], 1), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visibleDeleteModal,
      "id": "delete-modal"
    },
    on: {
      "close": _vm.toggleDeleteModal
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('div', {
    staticClass: "text-cente mt-6 mb-4"
  }, [_vm._v("Apakah Anda yakin akan menghapus hub ini?")]), _c('div', {
    staticClass: "flex justify-center items-center gap-4"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Ya",
      "type": "secondary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.deleteItem();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Tidak",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.toggleDeleteModal();
      }
    }
  })], 1)])], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }